const AUTH_STORAGE_KEYS = [
  "token",
  "user",
  "user_info",
  "userID",
  "subdomain",
  "username",
  "surname",
  "othernames",
  "fullname",
  "digital_signature",
  "role",
  "email",
  "subscription_data",
  "bank_details",
  "checkIn",
  "currency",
  "admin",
  "staff",
  "docdash",
  "nursedash",
  "phadash",
  "profile_picture",
  "gender",
  "birth_date",
  "location",
  "phone",
  "position",
  "department",
  "speciality",
  "subaccount",
] as const;

export function readStoredValue(key: string): string | null {
  return sessionStorage.getItem(key) || localStorage.getItem(key);
}

export function parseStoredJson<T>(key: string): T | null {
  const value = readStoredValue(key);
  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value) as T;
  } catch {
    return null;
  }
}

export function clearAuthStorage(): void {
  AUTH_STORAGE_KEYS.forEach((key) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
  });
  globalUserInfo = null;
}

export let globalUserInfo: any = null;

export function setGlobalUserInfo(data: any): void {
  globalUserInfo = data;
  sessionStorage.setItem("user_info", JSON.stringify(data));
  localStorage.setItem("user_info", JSON.stringify(data));
}

export function getGlobalUserInfo(key?: string): any {
  if (!globalUserInfo) {
    globalUserInfo = parseStoredJson("user_info") || parseStoredJson("user");
  }
  if (key && globalUserInfo) {
    return globalUserInfo[key];
  }
  return globalUserInfo;
}

export { AUTH_STORAGE_KEYS };
